import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInputField = ({ value, onChange }) => {
  const handleChange = (value, country) => {
    if (onChange) {
      onChange({
        target: {
          value: `+${value}`,
        },
      });
    }
  };

  // Remove the '+' if present for the PhoneInput value
  const inputValue = value ? value.replace(/^\+/, "") : "";

  return (
    <div className="relative phone-input-wrapper">
      <PhoneInput
        country={"us"}
        value={inputValue}
        onChange={handleChange}
        enableSearch
        searchPlaceholder="Search country..."
        inputProps={{
          required: true,
        }}
        containerStyle={{
          width: "100%",
        }}
        inputStyle={{
          width: "100%",
          height: "56px",
          fontSize: "16px",
          backgroundColor: "white",
          border: "1px solid #E1E0E0",
          borderRadius: "8px",
        }}
        buttonStyle={{
          border: "1px solid #E1E0E0",
          borderRight: "none",
          backgroundColor: "white",
          borderRadius: "8px 0 0 8px",
        }}
        dropdownStyle={{
          width: "300px",
          maxHeight: "300px",
          borderRadius: "8px",
          border: "1px solid #E1E0E0",
        }}
      />
    </div>
  );
};

export default PhoneInputField;
